import * as Yup from 'yup';
import { appReleaseFormModel, featureFormModel } from './appReleaseFormModel';

const {
    formField: {
        version,
        application,
        features
    }
} = appReleaseFormModel;

export const validationSchema = Yup.object().shape({
    [version.name]: Yup.string().required(version.requiredErrorMsg).max(50, 'La versión no puede exceder 50 caracteres'),
    [application.name]: Yup.object().shape({
        value: Yup.string().required(),
        label: Yup.string().required()
    }).default(undefined) 
    .required(`${application.requiredErrorMsg}`),
    [features.name]: Yup.array()
        .of(
            Yup.object().shape({ 
                [featureFormModel.moduleName.name]: Yup.string()
                    .required(featureFormModel.moduleName.requiredErrorMsg)
                    .max(100, 'El nombre del módulo no puede exceder 100 caracteres'),
                [featureFormModel.title.name]: Yup.string()
                    .required(featureFormModel.title.requiredErrorMsg)
                    .max(255, 'El título no puede exceder 255 caracteres'),
                [featureFormModel.description.name]: Yup.string()
                    .required(featureFormModel.description.requiredErrorMsg)
            })
        )
        .min(1, features.requiredErrorMsg)
        .required(features.requiredErrorMsg)
});
